import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const OutlookCalendarActions = {
  async authorizeOutlookCalendar () {
    return axiosRequest.
      patch('/users/outlook_calendar/authorize').
      then(({ data }) => location.replace(data)).
      catch(handleError)
  },

  async createCalendarOnOutlookCalendar ({ commit }) {
    return axiosRequest.
      post('/users/outlook_calendar/create_calendar').
      then(({ data }) => commit('setOutlookCalendarInfo', data)).
      catch(handleError)
  },

  async deauthorizeOutlookCalendar ({ commit, dispatch }) {
    return axiosRequest.
      delete('/users/outlook_calendar/deauthorize').
      then(({ data }) => {
        commit('setCurrentUser', data.user, { root: true })
        dispatch('refreshOutlookCalendarInfo')
      }).
      catch(handleError)
  },

  async refreshOutlookCalendarInfo ({ commit }) {
    return axiosRequest.
      get('/users/outlook_calendar/info').
      then(({ data }) => commit('setOutlookCalendarInfo', data)).
      catch(handleError)
  },

  async resyncOutlookCalendar ({ commit }) {
    return axiosRequest.
      post('/users/outlook_calendar/resync').
      then(_ => commit('updateOutlookCalendarInfo', { sync: { running: true, progress: 0 } })).
      catch(handleError)
  },

  async updateOutlookCalendarInfo ({ commit }, data) {
    commit('updateOutlookCalendarInfo', data)
  },
}
